import { SafeImg } from './ScrollReveal';

const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20reading%20tutorial%20thumbnail%20style%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20digital%20tablet%20showing%20vertical%20scroll%20manga%20reading%20interface%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20editorial%20quality%2C%20no%20text&width=640&height=360&seq=media-01&orientation=landscape',
    title: '99漫画 · 下拉式阅读体验',
    desc: '一镜到底展示下拉式流畅阅读',
    duration: '02:35',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20comic%20collection%20browsing%20thumbnail%20style%20with%20warm%20amber%20and%20cream%20tones%2C%20colorful%20manga%20cover%20thumbnails%20displayed%20on%20a%20tablet%20screen%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20editorial%20quality%2C%20no%20text&width=640&height=360&seq=media-02&orientation=landscape',
    title: '如何使用分类和收藏功能',
    desc: '快速上手99漫画分类浏览与书架管理',
    duration: '01:48',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mobile%20app%20demonstration%20thumbnail%20style%20with%20warm%20peach%20and%20cream%20tones%2C%20smartphone%20showing%20manga%20reading%20app%20interface%20in%20dark%20mode%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20editorial%20quality%2C%20no%20text&width=640&height=360&seq=media-03&orientation=landscape',
    title: 'APP夜间模式使用指南',
    desc: '深色模式保护视力，夜间看漫画更舒适',
    duration: '01:22',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20recommendation%20video%20thumbnail%20with%20warm%20coral%20and%20cream%20tones%2C%20colorful%20manga%20panel%20collage%20background%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20editorial%20quality%2C%20no%20text&width=640&height=360&seq=media-04&orientation=landscape',
    title: '本月必看漫画推荐合集',
    desc: '编辑精选十部高分漫画一网打尽',
    duration: '04:15',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-accent-100 text-accent-800 mb-3 whitespace-nowrap">
            视频专区
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            看视频快速了解99漫画的使用技巧与精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <SafeImg
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 text-xs rounded bg-black/60 text-background-50 whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}